/*
  INBAR+co — Homepage JS
  File: assets/inbar-homepage.js
  Loaded by: sections/inbar-homepage.liquid (end of section)

  Follows the same patterns as assets/inbar-concerns.js:
  — All functions namespaced under icHp* to avoid collisions
  — No dependencies, vanilla JS only
  — Wrapped in IIFE to avoid polluting global scope
  — Public functions attached to window.* where Liquid onclick= needs them
*/

(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════
     PILLAR ACCORDION (mobile only)
     One open at a time. Aria-expanded for accessibility.
     Pattern mirrors icToggleStep in inbar-concerns.js
  ══════════════════════════════════════════════════════ */
  window.icHpTogglePillar = function (btn) {
    var acc     = btn.closest('.ic-hp-pillar-acc');
    var wasOpen = acc.classList.contains('open');

    // close all
    document.querySelectorAll('.ic-hp-pillar-acc').forEach(function (a) {
      a.classList.remove('open');
      var trigger = a.querySelector('.ic-hp-pillar-acc__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });

    // open this one if it was closed
    if (!wasOpen) {
      acc.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  /* ══════════════════════════════════════════════════════
     TESTIMONIALS — show all on mobile tap
     "Show more" reveal for mobile (desktop shows all via grid)
  ══════════════════════════════════════════════════════ */
  function initTestimonialReveal () {
    var hidden = document.querySelectorAll('.ic-hp-testimonial--hidden');
    if (!hidden.length) return;

    // Build a "Show all reviews" trigger below the first testimonial
    var first = document.querySelector('.ic-hp-testimonial');
    if (!first) return;

    var btn = document.createElement('button');
    btn.className   = 'ic-hp-testimonials__show-more';
    btn.textContent = 'Show all reviews';
    btn.style.cssText = [
      'display:block',
      'width:100%',
      'padding:1.2rem var(--pad-mobile)',
      'background:none',
      'border:none',
      'border-top:1px solid rgba(255,255,255,0.12)',
      'font-family:var(--inbar-sans)',
      'font-size:0.62rem',
      'font-weight:700',
      'letter-spacing:0.24em',
      'text-transform:uppercase',
      'color:rgba(255,255,255,0.65)',
      'cursor:pointer',
      'text-align:left'
    ].join(';');

    first.parentNode.insertBefore(btn, first.nextSibling);

    btn.addEventListener('click', function () {
      hidden.forEach(function (t) { t.classList.remove('ic-hp-testimonial--hidden'); });
      btn.remove();
    });

    // Hide trigger on desktop (grid shows all anyway)
    function checkBreakpoint () {
      btn.style.display = window.innerWidth >= 768 ? 'none' : 'block';
    }
    checkBreakpoint();
    window.addEventListener('resize', checkBreakpoint);
  }

  /* ══════════════════════════════════════════════════════
     CONCERN TILES — close scroll hint after first swipe
  ══════════════════════════════════════════════════════ */
  function initScrollHints () {
    document.querySelectorAll('.ic-hp-concerns__scroll, .ic-hp__products-scroll').forEach(function (el) {
      var hint = el.previousElementSibling;
      if (!hint || !hint.classList.contains('ic-hp__scroll-hint')) return;
      el.addEventListener('scroll', function onFirstScroll () {
        hint.style.opacity = '0';
        hint.style.transition = 'opacity 0.3s';
        el.removeEventListener('scroll', onFirstScroll);
      }, { passive: true });
    });
  }

  /* ══════════════════════════════════════════════════════
     HERO VIDEO — pause when out of viewport (perf)
  ══════════════════════════════════════════════════════ */
  function initHeroVideo () {
    var video = document.querySelector('.ic-hp-hero__video');
    if (!video || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          video.play().catch(function () {}); // autoplay may be blocked
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.1 });

    obs.observe(video);
  }

  /* ══════════════════════════════════════════════════════
     BESTSELLER ATC — inline add-to-bag from product cards.
     Submits via fetch, then dispatches cart:open event so the
     cart drawer auto-opens (same pattern as kits index page).
  ══════════════════════════════════════════════════════ */
  function initBestsellerATC () {
    var forms = document.querySelectorAll('[data-ic-hp-atc-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.disabled) return;

        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return;
        var variantId = variantInput.value;

        var originalLabel = '';
        if (btn) {
          btn.disabled = true;
          originalLabel = btn.textContent;
          btn.textContent = 'Adding\u2026';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Add failed');
            return r.json();
          })
          .then(function () {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            try {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true, detail: { cart: cart } }));
              document.dispatchEvent(new CustomEvent('cart:add', { detail: { cart: cart } }));
            } catch (err) {
              // older browsers — silent fallback
            }
            if (btn) {
              btn.disabled = false;
              btn.textContent = originalLabel;
            }
          })
          .catch(function (err) {
            console.error('INBAR Homepage: bestseller ATC failed', err);
            if (btn) {
              btn.disabled = false;
              btn.textContent = originalLabel || 'Add to Bag';
            }
          });
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     INIT — run after DOM ready
  ══════════════════════════════════════════════════════ */
  function init () {
    initTestimonialReveal();
    initScrollHints();
    initHeroVideo();
    initBestsellerATC();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
